const availableRoutes = {
    ROOT: 'root',
    LISTING_PAGE: 'listing_page',
    AMENITIES: 'amenities',
    LOCATION: 'location',
    CAROUSEL: 'carousel',
    CIVIL_CODE_DISCLAIMER: 'civil_code_disclaimer',
    VERTICAL_CAROUSEL: 'vertical_carousel',
    DESCRIPTION: 'description',
    UNIT_DESCRIPTION: 'unit_description',
    INQUIRY: 'inquiry',
    MAP: 'map',
    OWNER_PROFILE: 'ownerProfile',
    REVIEWS: 'reviews',
    SEARCH: 'search',
    SEARCH_DATE_PICKER: 'searchDatePicker',
    SEARCH_GUEST_PICKER: 'searchGuestPicker',
    VIRTUAL_TOUR: 'virtualTour',
    DATE_PICKER: 'date_picker',
    GUEST_SELECTOR: 'guest_selector',
    REQUEST_TO_BOOK: 'request_to_book'
};

function getRoutes(baseUrlPath = '/') {
    return {
        '/': {
            id: availableRoutes.ROOT
        },
        [`${baseUrlPath}`]: {
            id: availableRoutes.LISTING_PAGE
        },
        [`${baseUrlPath}?r=${availableRoutes.AMENITIES}`]: {
            id: availableRoutes.AMENITIES
        },
        [`${baseUrlPath}?r=${availableRoutes.OWNER_PROFILE}`]: {
            id: availableRoutes.OWNER_PROFILE
        },
        [`${baseUrlPath}?r=${availableRoutes.LOCATION}`]: {
            id: availableRoutes.LOCATION
        },
        [`${baseUrlPath}?r=${availableRoutes.CAROUSEL}`]: {
            id: availableRoutes.CAROUSEL
        },
        [`${baseUrlPath}?r=${availableRoutes.CIVIL_CODE_DISCLAIMER}`]: {
            id: availableRoutes.CIVIL_CODE_DISCLAIMER
        },
        [`${baseUrlPath}?r=${availableRoutes.VERTICAL_CAROUSEL}`]: {
            id: availableRoutes.VERTICAL_CAROUSEL
        },
        [`${baseUrlPath}?r=${availableRoutes.DESCRIPTION}`]: {
            id: availableRoutes.DESCRIPTION
        },
        [`${baseUrlPath}?r=${availableRoutes.UNIT_DESCRIPTION}`]: {
            id: availableRoutes.UNIT_DESCRIPTION
        },
        [`${baseUrlPath}?r=${availableRoutes.INQUIRY}`]: {
            id: availableRoutes.INQUIRY
        },
        [`${baseUrlPath}?r=${availableRoutes.MAP}`]: {
            id: availableRoutes.MAP
        },
        [`${baseUrlPath}?r=${availableRoutes.REVIEWS}`]: {
            id: availableRoutes.REVIEWS
        },
        [`${baseUrlPath}?r=${availableRoutes.SEARCH}`]: {
            id: availableRoutes.SEARCH
        },
        [`${baseUrlPath}?r=${availableRoutes.SEARCH_DATE_PICKER}`]: {
            id: availableRoutes.SEARCH_DATE_PICKER
        },
        [`${baseUrlPath}?r=${availableRoutes.SEARCH_GUEST_PICKER}`]: {
            id: availableRoutes.SEARCH_GUEST_PICKER
        },
        [`${baseUrlPath}?r=${availableRoutes.VIRTUAL_TOUR}`]: {
            id: availableRoutes.VIRTUAL_TOUR
        },
        [`${baseUrlPath}?r=${availableRoutes.DATE_PICKER}`]: {
            id: availableRoutes.DATE_PICKER
        },
        [`${baseUrlPath}?r=${availableRoutes.GUEST_SELECTOR}`]: {
            id: availableRoutes.GUEST_SELECTOR
        }
    };
}

export default getRoutes;
export {getRoutes, availableRoutes};
